<div id="app">
    <app-header></app-header>
    <div class="content" #mainContent>
        <router-outlet></router-outlet>
    </div>
</div>
